<template>
  <div class="transfer-request-table">
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      class="elevation-1"
      no-data-text="ไม่มีข้อมูลคำขอย้าย"
    >
      <!-- วันเดือนปีเกิด -->
      <template v-slot:item.brith_day="{ item }">
        {{ item.brith_day }}
      </template>

      <!-- วันที่บรรจุ -->
      <template v-slot:item.appoin_day="{ item }">
        {{ formatAppointmentDate(item) }}
      </template>

      <!-- วันที่คำสั่ง -->
      <template v-slot:item.collegePersonnelAppOrderDate="{ item }">
        {{ formatThaiDate(item.collegePersonnelAppOrderDate) }}
      </template>

      <!-- ปุ่มยกเลิก -->
      <template v-slot:item.actions="{ item }">
        <v-chip
          v-if="item.collegeRegStatus === 'req'"
          dark
          color="warning"
          @click="$emit('cancel-request', item.personalIDcardReq)"
        >
          <v-icon left>mdi-close-circle-outline</v-icon>
          ขอยกเลิกรับย้าย
        </v-chip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "TransferRequestTable",
  
  props: {
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      headers: [
        { text: "สังกัดเดิม", align: "left", value: "OldCollege" },
        { text: "เลขที่ตำแหน่งเดิม", align: "left", value: "id_position" },
        { text: "รหัสบัตรประชาชน", align: "left", value: "id_card" },
        { text: "ชื่อ-นามสกุล", align: "left", value: "frist_names" },
        { text: "ตำแหน่ง", align: "center", value: "name_postion" },
        { text: "เลขที่ตำแหน่งใหม่", align: "center", value: "collegeNewIdPosition" },
        { text: "สาขาวิชา", align: "center", value: "branch_name_th" },
        { text: "วันเดือนปีเกิด", align: "center", value: "brith_day" },
        { text: "วันเดือนปีบรรจุ", align: "center", value: "appoin_day" },
        { text: "คำสั่งที่", align: "center", value: "collegePersonnelAppOrder" },
        { text: "วันที่ปฏิบัติหน้าที่", align: "center", value: "collegePersonnelAppOrderDate" },
        { text: "แก้ไข", align: "center", value: "actions" }
      ]
    };
  },

  methods: {
    formatAppointmentDate(item) {
      return `${item.appoin_day}/${item.appoin_month}/${item.appoin_year}`;
    },

    formatThaiDate(date) {
      if (!date) return "";
      return this.$moment(date)
        .add(543, "years")
        .format("D MMMM YYYY");
    }
  }
};
</script>

<style scoped>
.transfer-request-table {
  margin-bottom: 24px;
}
</style>